import { ErrorWithData } from "shared/error/errorWithData";
import { SiteSurveyUnitAttribute } from "./types/siteSurveyUnitAttribute";
import { Attribute } from "api/types/attribute";

export function getMatchingAttributeConfig(
  attributeConfigs: Attribute[],
  attribute: SiteSurveyUnitAttribute
): Attribute {
  const matchingConfig = attributeConfigs.find(
    (c) => c.id === attribute.attributeId
  );
  if (!matchingConfig)
    throw new ErrorWithData(`Can't find matching attributes`, {
      attributeConfigs: attributeConfigs,
      attribute,
    });

  return matchingConfig;
}
